import { type FC } from 'react'
import { Configure, type ConfigureProps } from 'react-instantsearch'

type ConfigureWithNeuralProps = ConfigureProps & {
  disableNeuralSearch?: boolean
}

const ConfigureWithNeural: FC<ConfigureWithNeuralProps> = (neuralProps) => {
  return <Configure {...neuralProps} />
}

export { ConfigureWithNeural }
